var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_305_1743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 17.8125H2.34375C1.48082 17.8125 0.78125 17.1129 0.78125 16.25V3.75C0.78125 2.88707 1.48082 2.1875 2.34375 2.1875H6.875C7.73793 2.1875 8.4375 2.88707 8.4375 3.75V16.25C8.4375 17.1129 7.73793 17.8125 6.875 17.8125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 8.4375H13.125C12.2621 8.4375 11.5625 7.73793 11.5625 6.875V3.75C11.5625 2.88707 12.2621 2.1875 13.125 2.1875H17.6562C18.5192 2.1875 19.2188 2.88707 19.2188 3.75V6.875C19.2188 7.73793 18.5192 8.4375 17.6562 8.4375Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 17.8125H13.125C12.2621 17.8125 11.5625 17.1129 11.5625 16.25V13.125C11.5625 12.2621 12.2621 11.5625 13.125 11.5625H17.6562C18.5192 11.5625 19.2188 12.2621 19.2188 13.125V16.25C19.2188 17.1129 18.5192 17.8125 17.6562 17.8125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_1743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardOne);
export default __webpack_public_path__ + "static/media/dashboardOne.48b67dafe0398298b93d462a4154cb4d.svg";
export { ForwardRef as ReactComponent };